import { Component, Prop, Vue } from 'nuxt-property-decorator';
// @ts-ignore
import { directive } from 'v-click-outside-x';

@Component({
  directives: {
    clickOutside: directive
  }
})
export default class CustomTooltip extends Vue {
  @Prop()
  arrow!: 'top-left' | 'top-center' | 'top-right' |
    'right-top' | 'right-center' | 'right-bottom' |
    'left-top' | 'left-center' | 'left-bottom' |
    'bottom-left' | 'bottom-center' | 'bottom-right';

  @Prop({ type: Boolean, default: true })
  borderRadius!: boolean;

  @Prop({ type: String, default: 'none' })
  width!: string;

  @Prop({ type: String, default: 'none' })
  height!: string;

  get hasArrow(): boolean {
    return !!this.arrow;
  }

  get arrowClass(): string {
    return `tooltip--${this.arrow}`;
  }

  get hasFooter(): boolean {
    return !!this.$slots.action;
  }

  action(e: any): void {
    this.$emit('action', e);
  }

  onClickOutside (e: any): void {
    this.$emit('clickOutside', e);
  }
}
